<template>
  <section id="about-me" class="about-me">
    <div class="photo">
      <img src="/images/photos/my-photos/photo.jpg" alt="">
    </div>
    <div class="text">
      <h2 class="title">Обо мне</h2>
      <div class="p-wrapper">
        <p class="p">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam, nam illum quas est molestias quaerat. Quos accusamus magni consequuntur optio tempora reprehenderit illum aliquid voluptas quis ullam unde earum obcaecati, quidem nemo sequi eius laboriosam eaque quod dolorem culpa voluptatum enim! Soluta expedita laboriosam velit.
        </p>
        <p class="p">
          Eaque ut beatae ex aperiam voluptatibus itaque dignissimos nisi, natus, modi officiis nesciunt obcaecati iure quis unde voluptatem corrupti laudantium, iste vitae. Aut et ipsam sit id illo dolor, quaerat omnis facere similique nam itaque incidunt repudiandae!
        </p>
        <p class="p">
          Unde repellat facere repudiandae excepturi distinctio officia, voluptatibus, esse veritatis doloribus sit dignissimos sint rem libero laudantium debitis!
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutMe'
}
</script>

<style>

</style>
